<template>
	<div class="content">
		<div class="exam-search">
			<h2>证书查询</h2>
				<template v-if="result1"> 
				<div class="exam-search-result" v-if="hasData">
					<ul>
						<li v-for="item in certificateArr" :key="item" >
							<img :src="item" width="80%">
						</li>
					</ul>
				</div>
				<div class="exam-search-result" v-else>
					<div class="item"><img class="vam" src="../assets/baoming.png" width="180"><span>暂无证书信息</span></div>
				</div>
				</template>
				<template v-else>
					<div class="exam-search-item">
						<div class="line1">
							<el-input placeholder="证件号码" v-model="idcard" @input="VerifyCard()"><i slot="prefix" class="el-input__icon el-icon-postcard"></i></el-input>
							<div class="msg">{{msg2}}</div>
						</div>
						
						<div class="line1">
							<el-input placeholder="手机号" v-model="mobile" @input="VerifyInput()"  :class="msg==''?'':'red'"><i slot="prefix" class="el-input__icon el-icon-phone-outline"></i></el-input>
							<div class="msg">{{msg}}</div>
						</div>
						<div class="line2">
							<div class="line2-l">
							<el-input maxlength="4" placeholder="验证码" v-model="verifyCode" @input="VerifyInput1()" :class="msg1==''?'':'red'"><i slot="prefix" class="el-input__icon el-icon-chat-dot-round"></i></el-input>
							<div class="msg">{{msg1}}</div>
							</div>
							<template v-if="isShowCode"><div class="line2-r"><a href="javascript:void(0)" @click="GetMobileToken(15)">获取验证码</a></div> </template>
							<template v-else>  <div class="line2-r"><el-button type="info" plain disabled>重新获取({{seconds}}s)</el-button></div> </template>
						</div>
						<div class="clear"></div>
						<el-button type="primary" @click="search()">查 询</el-button>
					</div>
				</template>
		</div>
    </div>
</template>
<style scoped>
.exam-search{background:#fff; margin-top:24px; }
.exam-search h2{ height:84px; line-height:84px; font-size:24px;border-bottom:solid 1px #e8e8e8; color:#272727; font-weight:normal; text-align: center;}
.exam-search .exam-search-item{ padding-top:54px;}
.exam-search #tab-first{ padding-left:5%; height:64px; line-height: 64px;}
.exam-search-item {background:#fff;  margin-top:20px; margin-bottom:48px; padding:0 296px 94px;  }
.exam-search-result span{display: block; font-size: 16px; margin-top: 24px;}
.exam-search-item h2{ font-size:24px; margin:84px 0 60px; text-align:center; font-weight:normal; }
.exam-search-item .line1{ width:366px; height:38px; line-height:38px;  margin-bottom:24px; }
.exam-search-item .line1:hover{border-color:#1890ff;}
.exam-search-item .line2{margin-bottom:24px; overflow: hidden;}
.exam-search-item .line2-l{ width:234px;  float:left;}
.exam-search-item .line2-l:hover{border-color:#1890ff;}
.exam-search-item .line2-r{float:right;}
.exam-search-item .line2-r button{width:122px; font-size:14px;}
.exam-search-item .line2-r a{float:right; width:122px; border:solid 1px #DCDFE6;height:38px; line-height:38px; text-align:center;border-radius:3px; font-size:14px; color: #a1a1a1;}
.exam-search-item .line2-r a:hover{border-color:#1890ff; color:#1890ff;}
.exam-search-item .line2-r a:focus{border-color:#1890ff; color:#1890ff;}
.exam-search-item input:hover{ border-color:#1890ff !important;}
.exam-search-item p{color: #a4a4a4;font-size: 14px;height:38px; line-height:38px;margin-bottom:20px;margin-top:20px; }
.exam-search-item button{ width:368px; font-size: 16px;}
.exam-search-item .protocol i{ margin-left:80px; margin-right:5px;}
.login .protocol a{color:#1890ff;}
.exam-search-item .msg{font-size:14px; color:#f5222d; line-height:24px;}
.exam-search-item .msg1{text-align: center;}


.exam-search-result{background:#fff; overflow:hidden; margin:16px 0; font-size:14px; padding-bottom: 50px; }
.exam-search-result h2{ height:84px; line-height:84px; font-size:24px; border-bottom:solid 1px #e8e8e8; color:#272727; font-weight:normal; margin-bottom: 50px; text-align: center;}
.exam-search-result .item{text-align: center; padding-bottom:24px; color:#8c8c8c; line-height: 28px;}
.exam-search-result .label-item{ width:40%;display: inline-block; text-align: right; }
.exam-search-result .input-item{width:58%; display: inline-block; text-align: left; font-size:16px;color:#111; }
.exam-search-result input{height:20px;}
.exam-search-result .msg{font-size:14px; color:#f5222d; line-height:24px; position: absolute;}
.exam-search-result .msg1{font-size:14px; color:#f5222d; line-height:24px; position: absolute; padding-left:135px;}
.exam-search-result button{ height:32px; line-height:32px;text-align:center; font-size:16px;border:solid 1px #1890ff; background:#1890ff;color:#fff;border-radius: 5px; cursor: pointer; padding:0 13px; font-size:13px;}

.exam-search-result li{text-align: center;}

</style>
<script>
	export default {
		methods: {
			search(){
				
				const self = this;
				self.VerifyCard();
				self.VerifyInput();
				self.VerifyInput1();
				var type=3;
				
				if(self.mobile != "" && self.verifyCode != "" && self.idcard != ""){
					const self = this;
					var data= self.common.GetlocalStorage("UnLockUserData");
					var userId=JSON.parse(data).UserID;
					self.result1=false;
					self.result2=false;
					self.http.ajaxGet("GradeSearch?UserID="+userId+"&Card="+self.idcard+"&Mobile="+self.mobile+"&VerifyCode="+self.verifyCode+"&Type="+type,function(res){
					if(res.ReturnCode == 1){
						self.result1=true;
						var imgs=res.Result[0].Imgs;
						if(imgs){
							self.certificateArr=imgs.split(',');
							self.hasData=true;
						}else{
							self.hasData=false;
						}
					}else{
						self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定'});
					}	
					},function(err){
						self.$alert(err, '错误', {confirmButtonText: '确定'});
					})
				}
			},
			GetMobileToken(type){
				//获取验证码
				const self = this;
				self.VerifyInput();
				if(self.mobile != ""){
				var b=self.checkMobile(self.mobile);
					if(b){
						self.countDown();
						self.http.ajaxGet("VerificateCode?UseType="+type+"&Mobile="+self.mobile,function(res){
							if(res.ReturnCode == 1){
								var message=res.Message==="OK"?"验证码已发送":res.Message;
								self.$message({message: message, type: 'success'});   //提示成功消息
							}else{
								self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定'});
							}	
						},function(err){
							self.$alert(err, '错误', {confirmButtonText: '确定'});
						})
					}
				}
			},
			VerifyCard(){
				const self = this;
				self.isSubmit=false;
				if(self.idcard==""){
					self.msg2="请输入证件号码";
				}else{
					self.msg2="";

					var b=self.checkMobile(self.mobile);
					var b1=self.checkCode(self.verifyCode);
					if(b && b1)
						self.isSubmit=true;
					else
						self.isSubmit=false;
				}
			},
			VerifyInput(){
				const self = this;
				self.isSubmit=false;
				if(self.mobile=="")
					self.msg="请输入手机号";
				else{
					var b=self.checkMobile(self.mobile);
					if(!b){
						self.msg="手机号不合法";
					}else{
						self.msg="";
						
						var b=self.checkCode(self.verifyCode);
						if(b && self.isAgree)
							self.isSubmit=true;
					}
				}
			},
			VerifyInput1(){
				const self = this;
				self.isSubmit=false;
				if(self.verifyCode=="")
					self.msg1="请输入验证码";
				else{
					var b=self.checkCode(self.verifyCode);
					if(!b){
						self.msg1="验证码为4位数字";
					}else{
						self.msg1="";

						var b=self.checkMobile(self.mobile);
						if(b && self.isAgree)
							self.isSubmit=true;
					}
				}
			},
			checkMobile (number) {
				var partten = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
				return partten.test(number);
			},
			checkCode (number) {
				var partten = /^[0-9]{4}$/;
				return partten.test(number);
			},
			countDown(){
				const self = this;
				self.seconds=self.seconds-1;
				self.isShowCode=false;
				if(self.seconds==0)
				{
					self.seconds=60;
					self.isShowCode=true;
					return;
				}
				setTimeout(function(){self.countDown()},1000);
			},
			formatDate(date){
			    return this.http.dateFormat1("yyyy-MM-dd",date);
			},
			reset1(){
				this.result1=false;
				this.result2=false;
				this.mobile='';
				this.verifyCode='';
				this.idcard='';
			}
		},
		data() {
			return {
				mobile:"",
				verifyCode : "",
				msg:"",
				msg1:"",
				msg2:"",
				isSubmit:false,
				isShowCode:true,
				isAgree:true,
				seconds:60,
				activeName:"first",
				idcard:"",
				isSubmit:false,
				isShowCode:true,
				result1:false,
				result2:false,
				hasData:true,
				title:'电子竞技代练师-初级王者荣耀技能认证笔试',
				idcardNo:'',
				name:'',
				date:'',
				grade:'',
				comment:'',
				certificateArr:[]
			}
		},
		mounted: function () {
			// const self=this;
			// self.$alert('证书查询系统正在维护升级中，暂时无法查询', '', {
			// 	confirmButtonText: '确定',
			// 	type:"info",
			// 	showClose:false,
			// 	callback: action => {
			// 		self.$router.push({path:'/home'});
			// 	}
			// });
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/certificate-search.vue